import { render, staticRenderFns } from "./proformaDetail.vue?vue&type=template&id=16ff5f9e"
import script from "./proformaDetail.vue?vue&type=script&lang=js"
export * from "./proformaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports